/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Option,
    OptionFromJSON,
    OptionFromJSONTyped,
    OptionToJSON,
    UsersListAnotherName,
    UsersListAnotherNameFromJSON,
    UsersListAnotherNameFromJSONTyped,
    UsersListAnotherNameToJSON,
    WmdType,
    WmdTypeFromJSON,
    WmdTypeFromJSONTyped,
    WmdTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface UsersListResponse
 */
export interface UsersListResponse {
    /**
     * 
     * @type {number}
     * @memberof UsersListResponse
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UsersListResponse
     */
    name: string;
    /**
     * 
     * @type {Option}
     * @memberof UsersListResponse
     */
    country: Option;
    /**
     * 
     * @type {Array<WmdType>}
     * @memberof UsersListResponse
     */
    wmdTypes: Array<WmdType>;
    /**
     * 
     * @type {Array<UsersListAnotherName>}
     * @memberof UsersListResponse
     */
    anotherNames: Array<UsersListAnotherName>;
}

export function UsersListResponseFromJSON(json: any): UsersListResponse {
    return UsersListResponseFromJSONTyped(json, false);
}

export function UsersListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsersListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'country': OptionFromJSON(json['country']),
        'wmdTypes': ((json['wmdTypes'] as Array<any>).map(WmdTypeFromJSON)),
        'anotherNames': ((json['anotherNames'] as Array<any>).map(UsersListAnotherNameFromJSON)),
    };
}

export function UsersListResponseToJSON(value?: UsersListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'country': OptionToJSON(value.country),
        'wmdTypes': ((value.wmdTypes as Array<any>).map(WmdTypeToJSON)),
        'anotherNames': ((value.anotherNames as Array<any>).map(UsersListAnotherNameToJSON)),
    };
}


